import {BaseModel} from "../base.model";

export interface Level extends BaseModel {
    levelName?: string;
    paymentType?: string;
}

export const defaultLevel:  Readonly<Level> = {};